// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"1cafc15b","936":"490b7e70"}[chunkId] + ".chunk.css";
};